<template>
    <section class="login-now" loding="lazy" @click="closeCountryCodeOnOutsideClick">
                        <div class="loginInner1">
                            <div class="log-logo">
                                <img loading="lazy" :src="$siteSettings?.data?.aws_url + $siteSettings?.data?.storage_path.domain_image + $siteSettings?.data?.logo" alt="logo" class="logo-login">
                            </div>
                            <div class="featured-box-login">
                                <h1>{{ $t('forgot-password','Forgot Password?')}} <i class="fas fa-hand-point-down"></i></h1>
                                <form class="form-control-head">
                                    <div class="input-field">
                                        <div class="country-mob">
                                            <div class="form_list_select">
                                                <div class="country-select-card" ref="countryCodeWrapper">
                                                    <div class="country-select" v-if="countryCodeList && countryCodeList[contIndex]" @click="openCountryCode()" :class="{ 'disabled': timerRunning }">
                                                        <div class="country-icon">
                                                            <img :src="countryCodeList[contIndex]?.flag" alt="India" loading="lazy">
                                                        </div>
                                                        <div class="country-code">+  {{ countryCodeList[contIndex]?.phonecode }}</div>
                                                        <span class="arrowDown"></span>
                                                    </div> 
                                                    <div class="country-dropdown" :class="checkCountryCodeSelect ? 'open' :''">
                                                        <div class="country-list">
                                                            <template v-for="(allowedCountry, countryIndex) in countryCodeList">
                                                                <div class="country-item" :key="countryIndex"
                                                                    v-if="allowedCountry?.phonecode != countryCodeList[contIndex]?.phonecode"
                                                                    @click="selectCountryCode(countryIndex,allowedCountry?.phonecode)">
                                                                    <div class="country-icon">
                                                                        <img :src="allowedCountry?.flag" :alt="allowedCountry.name" loading="lazy">
                                                                    </div>
                                                                    <div class="country-name">{{ allowedCountry.name }}</div>
                                                                    <div class="country-code">+{{ allowedCountry.phonecode }}</div>
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="form_list_select_div-r">
                                                    <input type="tel" class="form-control pr-8" :placeholder="$t('enter-phone-number', 'Enter Mobile Number')+'*'" 
                                                        @input="form.mobileNo = $helper.sanitizeNumber(form.mobileNo,9999999999); validate()" 
                                                        id="phonenumber" v-model="form.mobileNo" minlength="10" maxlength="10" :disabled="resendOtp && timerRunning" :class="{'pr-10' : (!timerRunning && resendOtp)}">
                                                    <div class="mo-number-right" >
                                                        <button v-if="!loadingOtp" :disabled="timerRunning || form.mobileNo.length !== 10" type="button" @click="optCallWithValidationCheck()" id="otp-btn" class="sendOtp-btn" :class="{ 'btn-loading': loadingOtp, 'otp-btn' : (!timerRunning && !resendOtp), 'resend-btn' : (!timerRunning && resendOtp), 'disabled-btn': timerRunning || form.mobileNo.length !== 10 }">
                                                            {{ timerRunning ? formatTime(minutes) + ":" + formatTime(seconds) : resendOtp ? $t('resend-otp',"RESEND OTP") : $t('get-otp',"GET OTP") }}
                                                        </button>
                                                        <div v-if="loadingOtp" class="text-center" id="Otp_loader">
                                                            <div class="spinner-border" role="status">
                                                                <span class="visually-hidden">{{$t('loading','Loading')}}...</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="init.mobile && checkValidation?.mobile?.length > 0" class="thm-error-text">
                                            <div v-for="(err, index) in checkValidation?.mobile" :key="index">
                                                <p class="error-text">{{ $t(err.lang, err.error) }}</p>
                                            </div>
                                        </div>
                                        <div v-if="init.mobile && form.mobileNo.length == 10 && !isOtpApiCalled && getOTPmsg && !loadingOtp" class="thm-error-text">
                                            <div>
                                                <p class="error-text">{{$t('please-click-on-send-otp','Please Click on Get OTP')}}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="input-field" v-if="isOtpApiCalled">
                                        <div class="input-field-group">
                                            <input type="tel" class="form-control" id="inputPassword2" @input="form.otp = $helper.sanitizeNumber(form.otp, 999999); validate()"
                                            :placeholder="$t('enter-otp','Enter OTP')+'*'" v-model="form.otp" maxlength="6" />
                                            <div class="input-group-icon"><i class="fas fa-key"></i></div>
                                        </div>
                                        <!-- errors -->
                                        <div v-if="isOtpApiCalled && init.otp && checkValidation?.otp?.length > 0" class="thm-error-text">
                                            <div v-for="(err, index) in checkValidation?.otp" :key="index">
                                                <p class="error-text">{{ $t(err.lang, err.error) }}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="input-field">
                                        <div class="input-field-group">
                                            <input :type="passwordFieldType" maxlength="20" class="form-control" id="inputPassword4" 
                                                @input="form.password = $helper.sanitizeDetails('password', form.password, 20); validate()"
                                                :placeholder="$t('enter-password','Enter Password')+'*'" v-model="form.password" />
                                            <div class="showHide-icon" @click="togglePasswordVisibility('password')">
                                                <i v-if="passwordFieldType === 'password'" aria-hidden="true" class="fa fa-eye-slash"></i>
                                                <i v-else aria-hidden="true" class="fa fa-eye"></i>
                                            </div>
                                        </div>
                                        <div v-if="isOtpApiCalled && init.password && checkValidation?.password?.length > 0" class="thm-error-text">
                                            <span v-for="(err, index) in checkValidation?.password" :key="index">
                                                <p class="error-text">{{ $t(err.lang, err.error) }}</p>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="input-field">
                                        <div class="input-field-group">
                                            <input :type="confPasswordFieldType" maxlength="20" class="form-control" id="inputPassword5" 
                                                @input="form.confirmPassword = $helper.sanitizeDetails('password', form.confirmPassword, 20); validate()"
                                                :placeholder="$t('enter-confirm-password','Enter Confirm Password')+'*'" v-model="form.confirmPassword" />
                                            <div class="showHide-icon" @click="togglePasswordVisibility('confpassword')">
                                                <i v-if="confPasswordFieldType === 'password'" aria-hidden="true" class="fa fa-eye-slash"></i>
                                                <i v-else aria-hidden="true" class="fa fa-eye"></i>
                                            </div>
                                        </div>
                                        <div v-if="isOtpApiCalled && init.confirmPassword && checkValidation?.confirmPassword?.length > 0" class="thm-error-text">
                                            <span v-for="(err, index) in checkValidation?.confirmPassword" :key="index">
                                                <p class="error-text">{{ $t(err.lang, err.error) }}</p>
                                            </span>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <button type="button" class="btn btn-submit btn-login" @click="forgetPasswordCall()" >
                                            {{ $t('update-password',"Update Password")}}
                                            <i class="ml-2 fas fa-sign-in-alt"></i>
                                        </button>
                                    </div>

                                    <div class="for-pass">
                                        <p class="login-with-acc u-code">{{ $t('remember-your-password','Remember your password')}}?&nbsp;
                                            <router-link :to="{ name: 'Login' }" @click="refreshData">
                                                {{ $t('log-in','Login')}}
                                            </router-link>
                                        </p>
                                    </div>

                                    <p class="whats-with-acc u-code" >
                                        <router-link :to="{ name: 'SignUp' }" @click="refreshData"> 
                                            {{ $t('create-new-account','Create New Account')}}
                                        </router-link>
                                    </p>
                                </form>
                            </div>
                        </div>
    </section>
</template>

<script>
import commonAuth from '../services/commonAuth';
import validate from '../services/authValidation';

export default {
    name: "ForgetPassword",
    extends: commonAuth,
    data() {
        return {
            form: {
                code: this.$store.getters?.siteSettings?.country_code ? this.$store?.getters?.siteSettings.country_code : 91,
                mobileNo: "",
                otp: '',
                password: "",
                confirmPassword: "",
            },
            init:{
                mobile:false,
                otp:false,
                confirmPassword:false,
                password:false
            },
            checkCountryCodeSelect:false,
            defaultCountryCode : this.$store?.getters?.siteSettings?.country_code,
            loadingUpdate: false,
            validationErrors : null,
            contIndex:null,
        };
    },
    computed: {
        countryCodeList(){
            return this.$store?.getters?.siteSettings?.country_code_list;
        },
        checkValidation() {
			return this.validationErrors;
		}
    },
    mounted(){
        // this.contIndex =  this.countryCodeList?.findIndex(ci => ci.phonecode == this.defaultCountryCode)
        this.contIndex =  this.countryCodeList?.findIndex(ci => ci.phonecode == this.$siteSettings.data.country_code);
    },
    methods: {
        closeCountryCodeOnOutsideClick(event) {
            const countryCodeElement = this.$refs.countryCodeWrapper;
            // const countryCodeElement = this.$el.querySelector('.country-code-flag-top-wrapper');
            if (countryCodeElement && event && event.target && !countryCodeElement.contains(event.target)) {
                this.checkCountryCodeSelect = false;
            }
        },
         selectCountryCode(code,phone_code){
            this.contIndex = code;
            this.form.code = parseInt(phone_code)
            this.checkCountryCodeSelect = !this.checkCountryCodeSelect
        },
        openCountryCode(){
            this.checkCountryCodeSelect = !this.checkCountryCodeSelect
        },
        togglePasswordVisibility(fieldName) {
            if(fieldName == 'password'){
                this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
            } else {
                this.confPasswordFieldType = this.confPasswordFieldType === 'password' ? 'text' : 'password';
            }
            
        },
        forgetPasswordCall() {
            if (this.loadingUpdate) return;
            this.toggleInitPhn(true);
            this.getOTPmsg = true;
            if(this.isOtpApiCalled) {
                this.toggleOTPInit(true);
            }
            if(this.getOtp() && this.getOtp()?.length == 6){
                this.toggleInit(true)
            }
            if(Object.keys(this.validate()).length != 0) return;
            if (!this.isOtpApiCalled){ 
                return
            }
            this.forgotServiceCall();
        },
        async forgotServiceCall() {
            this.loadingUpdate = true;
            this.$store.dispatch('setGlobalLoader', true);            
            let data = {
                "mobile": this.form.mobileNo,
                "password": this.form.password,
                "confirm_password": this.form.confirmPassword,
                "otp": this.getOtp(),
                "countrycode":  this.form.code,
            };
            this.$apiCall('post','FORGOT_PASSWORD', data).then(response => {
                this.loadingUpdate = false;
                this.$store.dispatch('setGlobalLoader', false);
                if (response) {
                    if (response.status == 200) {
                        if (response?.data?.status == 0 || response.data.error) {
                            this.$errorToast(response?.data?.error);
                        }
                        else {
                            this.$successToast(response.data.success);
                            this.refreshData();
                            this.$router.push({name: 'Login'})
                        }
                    }
                }
            }).catch(error => {
                this.loadingUpdate = false;
                this.$store.dispatch('setGlobalLoader', false);
                if (error) {
                    this.$errorToast(error[0]);
                }
            });
        },
        validate(){
            this.validationErrors = validate.areFieldsValid(
                'forgot-password',
				this.form.mobileNo, 
				this.form.otp, 
				this.form.password,
				this.form.confirmPassword,
            );
            return this.validationErrors;                                                                                                    
        },
        validateMobileOnly(){
            this.validationErrors = validate.areFieldsValid(
                'only-mobile',
				this.form.mobileNo
            );
            return this.validationErrors;
        },
        toggleInitPhn(bool){
            this.init={
                mobile:bool
            }
        },
        toggleInit(bool){
            this.init={
                mobile:bool,
                otp:bool,
                confirmPassword:bool,
                password:bool
            }
        },
        toggleOTPInit(bool){
            this.init={
                otp:bool
            }
        },
        optCallWithValidationCheck(){
            this.getOTPmsg = true;
            this.toggleInitPhn(true);
            this.validate();
            if(this.form.mobileNo && this.form.mobileNo?.length == 10){
                this.sendOtpCall('forgot-password');
            }
        },
    },
};
</script>